/*
 * Authors: mariushirjanu
 * Created: 11/04/2017
 * Upgraded: 31/01/2023
 */
import { Component, Input, ViewEncapsulation} from '@angular/core';
import { trackByFunction } from '../formly/ga-formly.util';
import { IBreadcrumb } from './breadcrumb.service';

@Component({
  selector: 'breadcrumbs',
  template: `
    <div class="crumbs" *ngIf="breadcrumbs?.length > 1">
      <ol class="breadcrumb">
        <li *ngFor="let b of breadcrumbs; trackBy: trackByFunction">
          <breadcrumb [breadcrumb]="b"></breadcrumb>
          </li>
      </ol>
    </div>
  `,
  styleUrls: ['breadcrumbs.scss'],
  encapsulation: ViewEncapsulation.None
})
export class BreadcrumbsComponent {
  @Input() public breadcrumbs:IBreadcrumb[];

  public trackByFunction:Function = trackByFunction;

  constructor() {
    /***/
  }
}